export default __webpack_public_path__ + "static/media/Category-19.2e4bec58.jpg";